import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import swal from "sweetalert";
import moment from "moment";

const Personal = () => {
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [birthday, setBirthday] = useState("");
  const [country, setCountry] = useState("");
  const [allCountry, setAllCountry] = useState([]);
  const [infoBuffer, setInfoBuffer] = useState(false);

  const [data, setData] = useState(true);

  useEffect(() => {
    axios.get(`/api/user/personal/list/check`).then((res) => {
      setData(false);
      if (res.status === 200) {
        setFirstName(res.data?.userList?.first_name);
        setLastName(res.data?.userList?.last_name);
        setPhone(res.data?.userList?.phone);
        setEmail(res.data?.userList?.email);
        setBirthday(res.data?.userInfo?.dob);
        setCountry(res.data?.userInfo?.country);
        // setBirthday(res.data?.employmentList?.dob);
        // setCountry(res.data?.employmentList?.country);
      }
    });
  }, []);

  useEffect(() => {
    axios.get(`/api/user/allCountry`).then((res) => {
      setData(false);
      if (res.status === 200) {
        setAllCountry(res.data.country);
      }
    });
  }, []);

  const personHandle = (e) => {
    // alert('ok');
    e.preventDefault();
    setInfoBuffer(true);
    const formData = new FormData();

    formData.append("birthday", moment(birthday).format("yyyy-MM-DD"));
    formData.append("country", country);
    formData.append("first_name", first_name);
    formData.append("last_name", last_name);

    axios.post(`/api/user/personal-data/store`, formData).then((res) => {
      setInfoBuffer(false);
      if (res.data.status === 200) {
        if(res.data.message == "UserInfo Updated Successfully")
        {
          swal("Operation Successful", "Personal Information updated successfully!", "success");
        }else{
          swal(res.data.message, "", "success");
        }
      }
    });
  };

  return (
    <>
      <form onSubmit={personHandle}>
        <div className="row col-md-12 mx-md-2 justify-content-center">
          <h5 className="text-light text-left">Personal Information</h5>
          <div className="under-line-x mb-3 mt-1"></div>
        </div>
        <center>
          <div className="row col-sm-12 col-md-12 col-lg-10 justify-content-center">
            <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
              <div>Name</div>
              <div>&nbsp;:</div>
            </div>
            <div className="col-sm-12 col-md-8 mb-3">
              <input
                type="text"
                value={first_name}
                onChange={(e) => setFirstName(e.target.value)}
                className="from-control w-100 custom-con-input form-control-sm "
                placeholder="Enter your name"
              />
            </div>

            {/* <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
              <div>Last Name</div>
              <div>&nbsp;:</div>
            </div>
            <div className="col-sm-12 col-md-8 mb-3">
              <input
                type="text"
                value={last_name}
                onChange={(e) => setLastName(e.target.value)}
                className="from-control w-100 custom-con-input form-control-sm "
                placeholder="Enter your last name"
              />
            </div> */}

            <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
              <div>Email</div>
              <div>&nbsp;:</div>
            </div>
            <div className="col-sm-12 col-md-8 mb-3">
              <input
                type="email"
                value={email}
                disabled
                className="from-control w-100 custom-con-input form-control-sm "
              />
            </div>

            <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
              <div>Phone</div>
              <div>&nbsp;:</div>
            </div>
            <div className="col-sm-12 col-md-8 mb-3">
              <input
                disabled
                type="text"
                name="phone"
                value={phone}
                className="from-control w-100 custom-con-input form-control-sm "
                placeholder="Enter your number"
              />
            </div>

            <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
              <div>Birthday</div>
              <div>&nbsp;:</div>
            </div>
            <div className="col-sm-12 col-md-8 mb-3">
              <input
                type="date"
                onChange={(e) => setBirthday(e.target.value)}
                value={birthday}
                className="from-control w-100 custom-con-input form-control-sm "
                placeholder="Enter your number"
              />
            </div>

            <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
              <div>Country</div>
              <div>&nbsp;:</div>
            </div>

            <div className="col-sm-12 col-md-8 mb-3">
              <select
                className="form-control form-control-sm account-input-style"
                name="country"
                onChange={(e) => setCountry(e.target.value)}
                value={country}
              >
                <option value="">Select Your Country</option>
                {allCountry &&
                  allCountry.map((item) => (
                    <option value={item.name} selected={item.name === country}>
                      {" "}
                      {item.name}{" "}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
            <div></div>
            <div></div>
          </div>
          <div className="col-sm-12 col-md-8 mb-3 justify-content-center my-3 ">
            <div className="col-md-4">
              {data ? (
                <>
                  <button className="form-control form-control-sm account-input-style">
                    <i className="fas fa-spinner fa-pulse"></i>
                  </button>
                </>
              ) : (
                <button className="btn BTnInfo w-100 fw-bold">
                  {infoBuffer ? (
                    <>
                      <i className="fas fa-spinner fa-pulse"></i>&nbsp;
                    </>
                  ) : (
                    <></>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </center>
      </form>
    </>
  );
};

export default Personal;
